import { render } from "./Group_users.vue?vue&type=template&id=80106572&scoped=true"
import script from "./Group_users.vue?vue&type=script&lang=js"
export * from "./Group_users.vue?vue&type=script&lang=js"

import "./Group_users.vue?vue&type=style&index=0&id=80106572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80106572"]])

export default __exports__